<button
	mat-raised-button
	[id]="elementId"
	class="goldstar-btn"
	[disabled]="disabled"
	[ngStyle]="{ 'background-color': color, color: textColor, 'margin-left': '0.5rem', border: '1px solid ' + borderColor }"
	(click)="onButtonClicked($event)"
	[title]="tooltip"
	[ngClass]="customClass"
>
	<span *ngIf="imgSrc" [attr.title]="tooltip" class="image-container">
		<img [src]="imgSrc" width="22" alt="" />
	</span>
	<mat-icon *ngIf="icon && !imgSrc">{{ icon }}</mat-icon>
	<i *ngIf="boxIcon" [class]="boxIcon"></i>
	<ng-content></ng-content>
</button>
